import React from 'react';

import {disabledText} from './disabled-text.module.styl';

type Props = {
    children: React.ReactNode,
};
export const DisabledText: React.FC<Props> = ({children}) => {
    return (
        <span className={disabledText}>
            {children}
        </span>
    );
};
